import {useAppSelector} from "../redux/hooks";
import {TIPOPLAN} from "../helpers";

const TRES_DIAS_MS = 3 * 24 * 60 * 60 * 1000;

export function usePlanInfo() {
    const {tipoPlan, fechaCreacion} = useAppSelector(state => state.auth?.user ?? {});

    const freePlan = tipoPlan === TIPOPLAN.gratis;
    const isOlderThanThreeDays = !!fechaCreacion &&
        (Date.now() - new Date(fechaCreacion).getTime()) > TRES_DIAS_MS;

    return {freePlan, isOlderThanThreeDays};
}
